module.exports = __webpack_public_path__ + "static/media/aboutIcon.03a6eb80.png";